import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import { Image } from "react-bootstrap";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu";
import "../App.css";

export default function Navheader() {
    const [navbar, setNavbar] = useState(false);

    const changeBackground = () => {
        setNavbar(window.scrollY >= 9);
    };

    useEffect(() => {
        window.addEventListener("scroll", changeBackground);
        return () => {
            window.removeEventListener("scroll", changeBackground);
        };
    }, []);

    return (
        <Navbar
            collapseOnSelect
            expand="lg"
            fixed="top"
            bg="dark"
            variant="dark"
            className={navbar ? "navbar active" : "navbar"}
        >
            <Container>
                {/* Brand Logo on the Left */}
                <Navbar.Brand href="https://www.swmc.com/" target="_blank" rel="noreferrer noopener">
                    <Image
                        src={`${process.env.REACT_APP_CDN_LINK}/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png`}
                        fluid
                        alt="Sun West Mortgage Logo"
                        className="img-fluid w-50 main_logo"
                    />
                </Navbar.Brand>

                {/* Push Accessibility Icon to the Right */}
                <div className="ms-auto">
                    <UserWayAccessibilityMenu color="black" width={40} height={40} />
                </div>
            </Container>
        </Navbar>
    );
}
